// extracted by mini-css-extract-plugin
export default {"container":"ZlzqNl2c","icon":"Rpm6BDxq","iconContainer":"PpGLCVl_","label":"zLGnntGV","item":"fbnTdRTL","labelDesc":"kyZ1OnlI"};